<template>
  <div></div>
</template>

<script lang="ts" setup>
import { onBeforeMount } from 'vue';
import authenticationService from '@/services/authenticationService.ts';

onBeforeMount(async () => {
  await authenticationService.manageRedirection();
});
</script>
